<template>
  <div class="card custom_list">
    <div class="custom_list__header">
      <h4 class="title">
        {{ translate('custom.add_device_in_list') }}
      </h4>
    </div>

    <div class="custom_list__content">
      <div class="add_block">
        <label> {{ translate('custom.title') }} </label>
        <tree-select
          :options="new_opt_custom_list"
          :placeholder="translate('custom.title')"
          v-model="device_list_id"
          :multiple="false"
          :clearable="false"
          :max-height="200"
        />
      </div>

      <div v-if="show_select_name_new_list" class="new_block">
        <fg-input
          v-model="device_list_name"
          class="name"
          type="text"
          :label="translate('custom.name')"
          :placeholder="translate('custom.name')"
        />
      </div>
    </div>


    <div class="custom_list__button">
      <button
        class="btn btn-success btn-fill btn-wd"
        @click.prevent="save"
      >
        {{ translate('save') }}
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: "ModalCustomDeviceList",
  props: ['device_list', 'opt_custom_list'],

  data () {
    return {
      device_list_id: null,
      device_list_name: ''
    }
  },
  mounted () {

  },
  deactivated(){

  },

  computed:{
    new_opt_custom_list(){
      let list = [...this.opt_custom_list]
      list.unshift({id: "add new", label: "➕ Add New List"})
      return list
    },
    show_select_name_new_list(){
      return this.device_list_id === "add new"
    }
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    save () {
      if (this.device_list_id !== "add new") {
        let list = {
          "device_list_id": this.device_list_id,
          "device_ids": this.device_list
        }
        this.$http.v1.addDevicesCustomDeviceList(list, (response) => {
          if (response.data) {
            this.global_notify('info', this.translate('custom.add_devices_success'))
            this.$store.dispatch('customListUpdate')
            this.$emit('close')
          }else{
            this.global_notify('danger', this.translate('custom.add_devices_error'))
          }
        })
      }else{
        let new_list = {
          "id": null,
          "name": this.device_list_name,
          "description": "!Description",
          "devices": this.device_list,
          "users": []
        }
        this.$http.v1.createCustomDeviceList(new_list, (response) => {
          if (response.data) {
            this.global_notify('info', this.translate('custom.add_list_success'))
            this.$store.dispatch('customListUpdate');
            this.$emit('close')
          }else{
            this.global_notify('danger', this.translate('custom.add_list_error'))
          }
        })
      }

    },

  }
}

</script>

<style lang='scss' scoped>

  .custom_list{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
    &__content{
      padding: 10px;
      height: 300px;
      textarea{
        flex: 10;
        width: 100%;
        height: 100%;
        overflow: auto;
        outline: none;
        &::-webkit-scrollbar {
          width: 10px;
        }
      }
    }
    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
      }
    }
  }
  @media (max-width:600px) {
    .custom_list{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
